import { Development, legendColorCollection } from "@models/development.model";
import { ChartConfiguration, TitleOptions } from "chart.js";

export const barChartTitleText = [
  "Per Apartment Remaining 20-Year Capital Need",
  "Compared to NYCHA Average ($)",
];

// export const barChartTitleText = "Per Apartment Remaining 20-Year Capital Need Compared to NYCHA Average ($)";
export const barChartAverageDevelopment = "Average Development";

// export const pieChartTitleText = ["Areas of Work as % of Remaining", "20-Year Capital Needs"];
export const pieChartTitleText = "Areas of Work as % of Remaining 20-Year Capital Needs";

export const doughnutChartTitleText = "Project Investment by Project Status";
export const doughnutChartBottomText = "Project Investment by Project Status: ";

export const chartFontFamily = "Plus Jakarta Sans";

export const pieChartColor = [
  "rgba(79, 121, 98, 1)",
  "rgba(98, 166, 157, 1)",
  "rgba(46, 107, 52, 1)",
  "rgba(97, 143, 139, 1)",
  "rgba(26, 67, 32, 1)",
  "rgba(62, 119, 109, 1)",
  "rgba(124, 192, 165, 1)",
  "rgba(209, 235, 230, 1)",
  "rgba(103, 165, 119, 1)",
  "rgba(165, 214, 201, 1)",
  "rgba(214, 234, 218, 1)",
  "rgba(204, 181, 167, 1)",
];
export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const numberFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const barChartTitle = {
  display: false,
  text: barChartTitleText,
  padding: { top: 10, bottom: 10 },
  color: "#000000",
  font: {
    size: 20,
    weight: "bold",
    family: chartFontFamily,
  },
};

export const pieChartTitle = {
  display: false,
  text: pieChartTitleText,
  color: "#000000",
  font: {
    size: 20,
    weight: "bold",
    family: chartFontFamily,
  },
  padding: { top: 10, bottom: 50 },
};

export const doughnutChartTopTitle = {
  display: false,
  text: doughnutChartTitleText,
  position: "top",
  color: "#000000",
  font: {
    size: 20,
    weight: "bold",
    family: chartFontFamily,
  },
  padding: { top: 10, bottom: 50 },
} as unknown as TitleOptions;

export const doughnutChartBottomTitle = {
  display: true,
  position: "bottom",
  color: "#000000",
  font: {
    size: 20,
    weight: "bold",
    family: chartFontFamily,
  },
} as TitleOptions;

export enum ChartType {
  bar = "bar",
  pie = "pie",
  doughnut = "doughnut",
}

export const barChartOptions: ChartConfiguration<"bar">["options"] = {
  responsive: true,

  scales: {
    y: { beginAtZero: true },
  },
  maintainAspectRatio: true,

  plugins: {
    title: barChartTitle,
    legend: {
      display: false,
    },
  },
  aspectRatio: 0.8,
};

export const pieChartOptions: ChartConfiguration["options"] = {
  responsive: true,
  plugins: {
    title: pieChartTitle,
    legend: {
      display: false,
    },
    datalabels: {
      align: "center",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      formatter: (value: string, ctx: any) => {
        if (ctx.chart.data.labels) {
          return value + "%";
        }
        return value;
      },
    },
  },
  aspectRatio: 0.9,
};

export function getDoughnutChartOptions(
  development: Development,
): ChartConfiguration<"doughnut">["options"] {
  return {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        display: true,
        labels: {
          boxWidth: 12,
          font: {
            size: 12,
          },
        },
      },
      title: doughnutChartTopTitle,
      subtitle: {
        ...doughnutChartBottomTitle,
        text: `${doughnutChartBottomText}${currencyFormatter.format(
          development?.areasOfWork
            .flatMap((x) => x.fiveYearCapitalNeeds)
            .reduce((acc, cur) => acc + Number(cur), 0),
        )}`,
      },
      datalabels: {
        display: true,
        anchor: "center",
        // formatter: function (value, context) {
        //   return context.chart.data.labels[context.dataIndex];
        // },
        // formatter: (value: any, ctx: any) => {
        //   return '%';
        // },
      },
    },
    aspectRatio: 0.8,
  };
}
